import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls the window back to the top on every route change,
// except when navigating to an in-page hash anchor (e.g. /#ou-en-etes-vous).
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
    }
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  return null;
}
